import { useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";

const TextArea = (props) => {
    const { t } = useTranslation();
    const { value, maxLength, counter, autoResize, minRows = 3, className, style, ...rest } = props;
    const textareaRef = useRef(null);

    const characterLimit = maxLength;
    const used = value != null ? value.length : 0;
    const remaining = characterLimit != null ? characterLimit - used : null;
    const isNearLimit = remaining != null && remaining < characterLimit * 0.1;
    const isAtLimit = remaining != null && remaining <= 0;

    const resize = useCallback(() => {
        if (!autoResize || !textareaRef.current) return;
        const el = textareaRef.current;
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
    }, [autoResize]);

    useEffect(() => {
        resize();
    }, [value, resize]);

    const counterColor = isAtLimit
        ? "text-danger fw-bold"
        : isNearLimit
        ? "text-warning"
        : "text-muted";

    return (
        <div className="textarea-wrapper" style={{ position: "relative" }}>
            <textarea
                ref={textareaRef}
                className={"form-control " + (className || "")}
                value={value}
                maxLength={maxLength}
                style={{
                    resize: autoResize ? "none" : "vertical",
                    overflow: autoResize ? "hidden" : "auto",
                    ...style,
                }}
                {...rest}
            />
            {counter && characterLimit != null && (
                <div className={`textarea-counter d-flex justify-content-end mt-1 small ${counterColor}`}>
                    <span>
                        {used.toLocaleString()} / {characterLimit.toLocaleString()} {t('characters')}
                        {isAtLimit && <span className="ms-1">— {t('limit_reached')}</span>}
                    </span>
                </div>
            )}
        </div>
    );
};

export default TextArea;
